import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { htmlSafe } from '@ember/template';

export default class HomeInitiativeCardComponent extends Component {
  @service store;

  @tracked _initiative = this.args.initiative ?? null;

  get initiative() {
    return this._initiative;
  }

  get progressBarStyle() {
    return htmlSafe(
      `width: ${this._initiative?.closedTicketsPercentage ?? 0}%`,
    );
  }

  @action
  loadInitiative() {
    if (!this.args.initiativeId) return;
    this.store
      .findRecord('initiative', this.args.initiativeId)
      .then((initiative) => {
        this._initiative = initiative;
      })
      .catch((error) => {
        console.error('Error loading initiative:', error);
      });
  }
}
